(function () {
  'use strict';

  function initFloater(trigger) {
    /* The theme editor re-renders a section via the Section Rendering API without
       firing DOMContentLoaded, so init must be re-runnable — and must not double-bind
       when the same node is passed twice. Without this the trigger silently loses its
       click handler after any setting change (popup stops opening in the editor). */
    if (trigger.dataset.spvfBound === '1') return;
    trigger.dataset.spvfBound = '1';

    var idSuffix = trigger.id.replace('spvf-trigger-', '');
    var popup = document.getElementById('spvf-popup-' + idSuffix);
    var closeBtn = document.getElementById('spvf-close-' + idSuffix);
    if (!popup || !closeBtn) return;

    /* Sibling, not a descendant — a <button> cannot nest inside a <button>. */
    var dismissBtn = document.getElementById('spvf-dismiss-' + idSuffix);
    var storeKey = 'spvf-dismissed-' + idSuffix;

    var dismissed = false;

    function hideFloater() {
      trigger.hidden = true;
      if (dismissBtn) dismissBtn.hidden = true;
    }

    function showFloater() {
      /* Never resurrect a floater the shopper explicitly dismissed. */
      if (dismissed) return;
      trigger.hidden = false;
      if (dismissBtn) dismissBtn.hidden = false;
    }

    try {
      if (window.sessionStorage && sessionStorage.getItem(storeKey) === '1') { dismissed = true; hideFloater(); }
    } catch (e) { /* storage blocked (private mode) — floater simply stays visible */ }

    var atcBtn = popup.querySelector('[data-spvf-atc]');
    var errorEl = popup.querySelector('[data-spvf-error]');
    var triggerVideo = trigger.querySelector('[data-festive-video]');
    var popupVideo = popup.querySelector('.spvf-popup__video');
    var lastFocused = null;

    function focusableElements() {
      return popup.querySelectorAll('button, [href], video[controls]');
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      var items = focusableElements();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        closePopup();
      } else {
        trapFocus(e);
      }
    }

    function openPopup() {
      if (!popup.hidden) return; /* already open — avoid stacking a second keydown listener */
      lastFocused = document.activeElement;
      popup.hidden = false;
      /* Get the floater out of the way while the dialog is up — it sits fixed at
         z-index 9200 and otherwise hovers over the popup's own backdrop. */
      hideFloater();
      if (triggerVideo) triggerVideo.pause();
      /* Attribute presence, not a "true"/"false" string: the string form silently
         fails if Liquid ever renders the boolean differently. Reduced motion is
         honoured here the same way sindhi-festive-motion.js does for the trigger. */
      if (popupVideo && popupVideo.hasAttribute('data-spvf-autoplay') &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var playPromise = popupVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
      }
      document.addEventListener('keydown', onKeydown);
      closeBtn.focus();
    }

    function closePopup() {
      if (popup.hidden) return;
      popup.hidden = true;
      showFloater();
      if (popupVideo) popupVideo.pause();
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
      /* Resumes the trigger's own video per the current reduced-motion
         preference (rather than a blind .play()) — reuses Task 3's
         matchMedia logic instead of reimplementing it here. */
      if (window.SindhiFestiveMotion) window.SindhiFestiveMotion.apply(trigger.parentElement || document);
    }

    trigger.addEventListener('click', openPopup);
    closeBtn.addEventListener('click', closePopup);

    if (dismissBtn) {
      dismissBtn.addEventListener('click', function (e) {
        e.preventDefault();
        dismissed = true;
        hideFloater();
        if (triggerVideo) triggerVideo.pause();
        try {
          if (window.sessionStorage) sessionStorage.setItem(storeKey, '1');
        } catch (err) { /* storage blocked — dismissal is then per-pageview only */ }
      });
    }
    popup.addEventListener('click', function (e) {
      if (e.target === popup) closePopup();
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled) return;
        var variantId = atcBtn.getAttribute('data-variant-id');
        if (!variantId) return;
        atcBtn.disabled = true;
        if (errorEl) errorEl.hidden = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) {
                throw new Error(data.description || 'Unable to add to cart');
              }
              return data;
            });
          })
          .then(function () {
            /* Close the popup BEFORE dispatching product:added. dispatchEvent
               is synchronous, so sindhi-cart-drawer.js's listener (which may
               auto-open the drawer) runs inside this call — the popup must
               already be out of the way, or its overlay and the drawer's own
               scroll-lock/restore fight each other. See design spec §7.2. */
            closePopup();
            document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: { id: parseInt(variantId, 10), variantId: variantId }
            }));
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.textContent = err.message;
              errorEl.hidden = false;
            }
          })
          .finally(function () {
            atcBtn.disabled = false;
          });
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[id^="spvf-trigger-"]').forEach(initFloater);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  /* Theme editor lifecycle — without this the section stops working after any
     setting change, because the re-rendered DOM never gets its listeners bound. */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
}());
